module.exports = __webpack_public_path__ + "img/icon-menu-challenge.a7021ada.svg";